/** The browser's own storage for the small per-browser memories (the one-time hint, Home's notifications row; the home-and-customers round
 *  lifted it out of `pushHint.ts`): `storage` undefined means the browser's own, null none at all. Reading it never throws: a private window
 *  or blocked site data gives none, and the memories only forget. */
export function localStore(storage?: Storage | null): Storage | null {
  if (storage !== undefined) return storage;
  try { return typeof window === "undefined" ? null : window.localStorage; } catch { return null; }
}
